/**
 * Created by sung on 2017-02-10.
 */
import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';
import { HttpModule} from '@angular/http';
import {NgModule} from '@angular/core';
import {TabViewModule, PanelModule, DataTableModule, SharedModule,PaginatorModule,DropdownModule,InputTextModule,CalendarModule} from 'primeng/primeng';
import {SharedService} from '../../service/shared_service';

import {FormsModule} from "@angular/forms";
import {RouterModule} from "@angular/router";
import {BrowserModule} from "@angular/platform-browser";
import {SelectItem} from "primeng/components/common/api";
import {MainPipeMoudle} from "../../pipe/main.pipe";
import {Logger, Options, Level } from "angular2-logger/core";
import {TranslatePipeMoudle} from "../../translate/translate.module.pipe"; // ADD THIS


@Component({
  selector: 'log-common-table',
  templateUrl: 'log_common_table.html'
})
export class LogCommonTableComponent implements OnInit {

  @Input()
  table_list : any;

  @Input()
  searchIDs : SelectItem[] =[];

  @Input()
  totalRecord : number;

  @Output()
  onPagination : EventEmitter<any> = new EventEmitter();

  constructor(private ss : SharedService, private logger : Logger) {
      this.ss = ss;
  }

  ngOnInit() {
    this.logger.debug("item ", this.table_list);

   // this.ss.getTableList().subscribe(item => this.table_list= item);
   // this.ss.getSearchIDs().subscribe(item => this.searchIDs = item);
   // this.ss.getTotalRecord().subscribe(item => this.totalRecord = item);

  }

  changePage(event: any) : void{
    this.logger.debug(event);
      this.onPagination.emit(event);
  }
}

@NgModule({
  imports: [PanelModule, TabViewModule, DataTableModule, SharedModule, CommonModule,PaginatorModule,DropdownModule,InputTextModule,BrowserModule,HttpModule, RouterModule,FormsModule,CalendarModule,MainPipeMoudle,TranslatePipeMoudle],
  exports: [LogCommonTableComponent],
  declarations: [LogCommonTableComponent],
  providers: [SharedService],
})

export class LogCommonTableModule {
}



// WEBPACK FOOTER //
// ./src/app/page/log/log_common_table.ts